import { InjectionToken } from "@angular/core";

// eslint-disable-next-line @typescript-eslint/ban-types
export interface SharedMapEndpoints<T extends string | number = keyof {}> {
    geoServerEndpoint: string;
    geoServerWfsEndpoint?: string;
    geotilerStylesUrl?: string;
    layersPrefix?: string;
    layers?: { [layerKey in T]?: string[] };
    styles?: { [styleKey in keyof this["layers"]]?: string[] };
    cqlFilters?: { [filterName in string]?: { layerName: string; true?: string; false?: string } };
}

export const SHARED_MAP_ENDPOINTS = new InjectionToken<SharedMapEndpoints<string | number>>("Shared map endpoints");
export const AZURE_MAPS_SUBSCRIPTION_KEY = new InjectionToken<string>("Azure Maps subscription key");
